import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateReportMutation } from "../graphql/mutations";
import type {
  CreateReportMutationType,
  CreateReportMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateReportMutation = (
  options?: MutationHookOptions<
    CreateReportMutationType,
    CreateReportMutationVariablesType
  >
) => {
  return useMutation<
    CreateReportMutationType,
    CreateReportMutationVariablesType
  >(CreateReportMutation, options);
};
